import { apiFetch } from './client';

const token = () => localStorage.getItem('token');

export const getPublicAlumniContent = () =>
  apiFetch('/alumni-content');

export const saveAdminAlumniContent = (body) =>
  apiFetch('/admin/alumni-content', { method: 'POST', token: token(), body });

export const uploadAdminAlumniBanner = (body) =>
  apiFetch('/admin/alumni-content/upload-banner', { method: 'POST', token: token(), body });
